import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Epic%20Japanese%20manga%20art%20style%20background%20with%20dynamic%20brush%20strokes%2C%20ink%20wash%20effect%2C%20abstract%20battle%20scene%20silhouettes%2C%20warm%20crimson%20and%20dark%20charcoal%20color%20palette%2C%20action%20lines%20and%20speed%20effects%2C%20dramatic%20composition%2C%20Japanese%20calligraphy%20texture%2C%20high%20contrast%20artistic%20background&width=1920&height=1080&seq=hero-bg-manga&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 text-primary-300 text-xs font-medium mb-6 animate-fade-in-up">
          <i className="ri-fire-line"></i>
          <span>全网最全刃牙漫画合集</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 mb-5 leading-tight animate-fade-in-up delay-100">
          刃牙漫画
          <span className="block text-primary-400 text-2xl md:text-3xl lg:text-4xl mt-2 font-normal">
            免费在线阅读 · 下拉式全集
          </span>
        </h1>

        <p className="text-sm md:text-base text-background-200/80 max-w-2xl mx-auto mb-8 leading-relaxed animate-fade-in-up delay-200">
          在线免费阅读刃牙漫画全集，提供下拉式即时观看体验。刃牙漫画在线看，
          无需下载，流畅浏览全部章节。从《刃牙》第一部到最新《刃牙道II》，
          經典格鬥漫畫一次收錄。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 animate-fade-in-up delay-300">
          <Link
            to="/category/all"
            className="w-full sm:w-auto px-8 py-3.5 rounded-md bg-primary-500 text-background-50 font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-all duration-200 flex items-center justify-center gap-2"
          >
            <i className="ri-book-open-line text-lg"></i>
            <span>立即开始阅读</span>
          </Link>
          <Link
            to="/category/latest"
            className="w-full sm:w-auto px-8 py-3.5 rounded-md bg-background-50/10 backdrop-blur-sm border border-background-50/20 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-background-50/20 transition-all duration-200 flex items-center justify-center gap-2"
          >
            <i className="ri-timer-line text-lg"></i>
            <span>查看最新更新</span>
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10 animate-fade-in-up delay-400">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">12+</div>
            <div className="text-xs text-background-300 mt-1">漫画作品</div>
          </div>
          <div className="w-px h-10 bg-background-50/20" />
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">400+</div>
            <div className="text-xs text-background-300 mt-1">漫画章节</div>
          </div>
          <div className="w-px h-10 bg-background-50/20" />
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">1600万+</div>
            <div className="text-xs text-background-300 mt-1">累计阅读量</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-2xl text-background-50/60"></i>
      </div>
    </section>
  );
}